import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { SummaryTable } from 'modules/salary_advance/pages/SummaryPage/SummaryTable'

export default function SummaryPage() {
  return (
    <ResponsivePage.Body variant="full">
      <SummaryTable />
    </ResponsivePage.Body>
  )
}
